import "babel-polyfill";
import jQuery from "jquery";
window.$ = window.jQuery = $ = jQuery;
import 'bootstrap';
import "slick-lightbox";
import "slick-carousel";
import "sticky-kit/dist/sticky-kit.js";
import "waypoints/lib/jquery.waypoints";
import "waypoints/lib/shortcuts/inview";

// import scrollMagic from "scrollmagic";
// import gsap from "gsap";
import "./plugins/bsnav.js";

import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/brands'
import '@fortawesome/fontawesome-free/js/v4-shims'

// Import everything from autoload
// import "./autoload/**/*";

import jqueryLazy from "./utils/jquery-lazy";
// import scrollmagicUtil from "./utils/scrollmagic-util";
// import scrollrevealJs from "./utils/scrollreveal";
import wowJs from "./utils/wow";
import sidebarJs from "./utils/sidebar";

// import onscreenJs from "./utils/onscreen";

// var controller = new ScrollMagic.Controller();
// var scene = new ScrollMagic.Scene();

// import "jquery-lazy/plugins/jquery.lazy.av"
// import "jquery-lazy/plugins/jquery.lazy.picture"
//import "waypoints/src/waypoint";

jqueryLazy();
// scrollmagicUtil();
// scrollrevealJs();
wowJs();
// onscreenJs();

sidebarJs($);

$(document).ready(function () {

    $(".js-slick-lightbox").slickLightbox({
        itemSelector: "> a"
    })

    function playVideo(obj, e) {
        obj.find('video').addClass('show-video');
        obj.find('picture').addClass('show-video');
        obj.find('video')[0].play();

        obj.find('picture').lazy({
            bind: "event"
        });
    }

    function pauseVideo(obj, e) {
        //obj.find('.js-hide-on-video').removeClass('show-video');
        obj.find('video').removeClass('show-video');
        obj.find('picture').removeClass('show-video');
        obj.find('video')[0].pause();
    }


    // $('.js-header-content').waypoint(function(direction) {
    //     if ( direction == 'down' ) {
    //         $('.js-header-content').addClass('is--hidden');
    //     } else {
    //         $('.js-header-content').removeClass('is--hidden');
    //     }
    // }, {
    //     offset: '100px'
    // })


    // $(this).waypoint(function(direction) {
    //     console.log(direction, this.element);
    //     if ( direction == 'down' ) {
    //         $(this.element).fadeOut();
    //     } else {
    //         $(this.element).fadeIn();
    //     }
    // }, {
    //     offset: function() {
    //         return -this.element.clientHeight
    //     }
    // });

    function setHeaderTransparence() {
        if ( $(window).scrollTop() <= $('.js--header-transparence').height() ) {
            var val = ($('.js--header-transparence').height() - $(window).scrollTop()) / $('.js--header-transparence').height();
            //console.log(val);
            if (val > 0 && val <= 1) {
                $('.js--header-transparence').css('opacity', val);
            }
        }
    }

    setHeaderTransparence();
    $(document).on('scroll', function() {
        setHeaderTransparence();
    });

    if ( $(".js-header-video").length ) {
        var inview = new Waypoint.Inview({
            element: $(".js-header-video"),
            enter: function (direction) {
                playVideo(inview.element);
                // inview.element.find('video')[0].play();
                // console.log(inview.element)
                //console.log('Enter triggered with direction ' + direction)
            },
            entered: function (direction) {
                playVideo(inview.element);
                //console.log('Entered triggered with direction ' + direction)
            },
            exit: function (direction) {
                //console.log('Exit triggered with direction ' + direction)
                // inview.element.find('video')[0].pause();
            },
            exited: function (direction) {
                pauseVideo(inview.element);
                //console.log('Exited triggered with direction ' + direction)
            }
        });
    }

});

